import React, { useState, useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../ApiUrl/meta_api";
import { useNavigate } from "react-router-dom";
import Footer from "../../Footer/Footer";
import {
  FaUserGraduate,
  FaBuilding,
  FaShieldAlt,
  FaFileAlt,
  FaLinkedin,
  FaBrain,
  FaUsers,
  FaUserTie,
  FaCode,
  FaChalkboardTeacher,
  FaProjectDiagram,
  FaFileSignature,
  FaClipboardCheck,
  FaHandshake,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";

// const PRIMARY = "#0e1e40";

const PlacementPage = () => {
  const [meta, setMeta] = useState({});
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: false,
      offset: 100,
      delay: 100,
    });

    // Directly access placement_page from data
    const PlacementMeta = data[0]?.placement_page;

    // Set meta state if PlacementMeta exists
    if (PlacementMeta) {
      setMeta(PlacementMeta);
    }
  }, []);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [activeDot, setActiveDot] = useState(0);

  const handleOpenModal = () => setShowModal(true);

  const trackRecords = [
    { icon: FaUserGraduate, title: "1,000+", subtitle: "Students Placed" },
    {
      icon: FaBuilding,
      title: "Top Recruiters",
      subtitle: "Infosys, Zoho, Capgemini",
    },
    {
      icon: FaShieldAlt,
      title: "100%",
      subtitle: "Placement Guarantee (Premium)",
    },
  ];

  const supportItems = [
    {
      icon: FaFileAlt,
      title: "Resume Writing",
      desc: "Get professionally tailored resumes that highlight your skills, experiences attention.",
    },
    {
      icon: FaLinkedin,
      title: "LinkedIn Optimization",
      desc: "Enhance your LinkedIn profile to improve visibility, attract recruiters.",
    },
    {
      icon: FaBrain,
      title: "Aptitude Practice",
      desc: "Sharpen your problem-solving and logical reasoning skills with daily aptitude quizzes .",
    },
    {
      icon: FaUsers,
      title: "GD Sessions",
      desc: "Participate in simulated group discussions to improve articulation, confidence .",
    },
    {
      icon: FaUserTie,
      title: "Mock HR Interviews",
      desc: "Gain confidence and improve your communication and HR interview simulations.",
    },
    {
      icon: FaCode,
      title: "Tech Prep",
      desc: "Master technical interviews with focused preparation on data structures, algorithms.",
    },
  ];

  const steps = [
    { icon: FaChalkboardTeacher, title: "Training" },
    { icon: FaProjectDiagram, title: "Project Work" },
    { icon: FaFileSignature, title: "Resume Setup" },
    { icon: FaClipboardCheck, title: "Placement Test" },
    { icon: FaHandshake, title: "Interview Drive" },
  ];

  const testimonials = [
    {
      id: 1,
      name: "Sara Wilsson",
      role: "Oracle",
      rating: 5,
      quote:
        "Export tempor illum tamen malis mollis eram quare irure esse labore quem cillum quid cillum malis quorum velit fore eram velit sunt aliqua noster fugiat irure amet legam anim culpa.",
    },
    {
      id: 2,
      name: "Jena Karlis",
      role: "Data Analysis",
      rating: 4,
      quote:
        "Enim nisi quem export duis labore cillum quae magna enim sint quorum nulla quem veniam duis minim tempor labore quem eram duis noster oute amet eram fore quis sint minim.",
    },
    {
      id: 3,
      name: "Divya N.",
      role: "TCS",
      rating: 5,
      quote:
        "Got my first job as a Data Engineer at TCS, thanks to their excellent training and support!",
    },
    {
      id: 4,
      name: "Siddharth P.",
      role: "Zoho",
      rating: 4,
      quote:
        "Secured an SDE role at Zoho after just 6 weeks. The mock interviews were a game-changer.",
    },
  ];

  const renderStars = (rating) => {
    return (
      <div className="text-warning">
        {"★".repeat(rating)}
        {"☆".repeat(5 - rating)}
      </div>
    );
  };

  const testimonialsPerPage = 2;
  const totalPages = Math.ceil(testimonials.length / testimonialsPerPage);
  const startIndex = activeDot * testimonialsPerPage;
  const currentTestimonials = testimonials.slice(
    startIndex,
    startIndex + testimonialsPerPage
  );

  return (
    <HelmetProvider>
      <div className="w-100" style={{ overflowX: "hidden" }}>
        <Helmet>
          <title>{meta?.title || "Placements - Berlin Technovation"}</title>
          <meta
            name="description"
            content={
              meta?.meta?.meta1?.content ||
              "Get professionally tailored resumes that highlight your skills, experiences attention."
            }
          />
        </Helmet>

        {/* Hero Section */}
        <div
          style={{ width: "100%" }}
          data-aos="fade-down"
          data-aos-delay="200"
        >
          <div
            className="position-relative"
            style={{
              backgroundImage: `url(${require("../../Img/images/BannerImage/PlacementBanner.jpg")})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              height: "350px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            {/* Overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                zIndex: 1,
              }}
            ></div>

            {/* Centered Heading */}
            <div
              className="position-absolute top-50 start-50 translate-middle text-center"
              style={{ zIndex: 2 }}
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <h1 className="fw-bold" style={{ color: "#008cff" }}>
                Placements
              </h1>
            </div>

            {/* Breadcrumb */}
            <div
              className="container h-100 d-flex align-items-end pb-4"
              style={{ zIndex: 2, position: "relative" }}
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <nav aria-label="breadcrumb">
                <ol
                  className="breadcrumb mb-0 px-3 py-2 rounded d-flex align-items-center"
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    backdropFilter: "blur(4px)",
                    display: "flex",
                  }}
                >
                  <li className="breadcrumb-item d-flex align-items-center">
                    <button
                      onClick={() => navigate("/")}
                      className="btn btn-link p-0 text-decoration-none"
                      style={{
                        color: "#0663ad",
                        fontWeight: "bold",
                        background: "none",
                        border: "none",
                      }}
                    >
                      Home
                    </button>
                  </li>
                  <li
                    className="breadcrumb-item active d-flex align-items-center"
                    aria-current="page"
                    style={{ color: "#191943" }}
                  >
                    Placements
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>

        {/* Track Record */}
        <section
          className="container py-5"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <h2 className="text-center mb-4">
            <span style={{ color: "#0663ad" }}>Track</span>{" "}
            <span className="text-black">Records</span>
          </h2>
          <div className="section-divider  mb-4"></div>
          <div className="row g-4">
            {trackRecords.map((item, i) => (
              <div
                key={i}
                className="col-12 col-md-6 col-lg-4"
                data-aos={
                  i === 0 ? "fade-right" : i === 1 ? "fade-up" : "fade-left"
                }
                data-aos-delay={400 + i * 100}
              >
                <div
                  className="p-4 rounded-3 shadow bg-white text-center transition-transform duration-300 hover-scale"
                  style={{
                    transformOrigin: "center",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)", // Soft shadow effect
                  }}
                >
                  <item.icon size={36} color="#0663ad" className="mb-3" />
                  <h4 className="fw-semibold" style={{ color: "gray" }}>
                    {item.title}
                  </h4>
                  <p className="text-muted mb-0">{item.subtitle}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Career Support Services */}
        <section
          className="py-5 bg-light"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div className="container">
            <h2
              className="text-center mb-4"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <span style={{ color: "#0663ad" }}>Career</span>{" "}
              <span className="text-black">Support Services</span>
            </h2>
            <div className="section-divider  mb-4"></div>
            <div className="row align-items-center">
              <div
                className="col-12 col-md-6 mb-4 mb-md-0"
                data-aos="fade-right"
                data-aos-delay="400"
              >
                <img
                  src={require("../../Img/images/placement-support-service.jpeg")}
                  alt="Career Support"
                  className="img-fluid rounded-3 shadow"
                />
              </div>
              <div
                className="col-12 col-md-6"
                data-aos="fade-left"
                data-aos-delay="400"
              >
                <ul className="list-unstyled">
                  {supportItems.map((item, i) => (
                    <li
                      key={i}
                      className="d-flex align-items-start mb-3"
                      data-aos="fade-up"
                      data-aos-delay={450 + i * 50}
                    >
                      <div className="me-3 mt-1">
                        <item.icon size={24} color="#0663ad" />
                      </div>
                      <div>
                        <h6
                          className="fw-semibold mb-1"
                          style={{ color: "gray" }}
                        >
                          {item.title}
                        </h6>
                        <p className="text-muted mb-0 small">{item.desc}</p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Placement Timeline */}
        <section className="py-5">
          <div className="container-fluid" data-aos="fade-up" duration="1000">
            <h2 className="text-center">
              <span style={{ color: "#0663ad" }}>Placement</span>{" "}
              <span className="text-dark">Timeline</span>
            </h2>
            <div className="section-divider mx-auto mb-4"></div>
            <div className="position-relative">
              <div
                className="position-absolute top-50 mx-5 start-0 translate-middle-y "
                style={{
                  height: "4px",
                  margin: "10px",
                  width: "80%",
                  zIndex: 1,
                  background: "#008cff",
                }}
              />
              <div
                className="d-flex flex-nowrap overflow-auto pb-4 px-3"
                style={{ gap: "60px", zIndex: 2, position: "relative" }}
              >
                {steps.map((step, i) => (
                  <div
                    key={i}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: i * 0.15 }}
                    viewport={{ once: true }}
                    className="text-center flex-shrink-0 mx-1"
                    style={{ width: "230px" }}
                  >
                    <div
                      className="rounded-circle  mx-auto mb-3 d-flex align-items-center justify-content-center shadow"
                      style={{
                        width: "36px",
                        height: "36px",
                        backgroundColor: "#008cff",
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "16px",
                        border: "3px solid white",
                        zIndex: 2,
                      }}
                    >
                      {i + 1}
                    </div>
                    <div
                      whileHover={{ scale: 1.05 }}
                      className="bg-white p-3 rounded shadow"
                      style={{ cursor: "pointer" }}
                    >
                      <step.icon size={20} className="mb-2" />
                      <h6 className="m-0" style={{ color: "#0663ad" }}>
                        {step.title}
                      </h6>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Success Stories */}
        <section
          className="py-5"
          style={{
            background: "linear-gradient(135deg, #000000 0%, #434343 100%)",
          }}
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div className="container">
            <h2
              className="text-center mb-4 text-white"
              data-aos="zoom-in"
              data-aos-delay="300"
            >
              <span style={{ color: "#008cff" }}>Success</span>{" "}
              <span className="text-white">Stories</span>
            </h2>
            <div className="section-divider  mb-4"></div>
            <div className="row justify-content-center">
              {currentTestimonials.map((st, i) => (
                <div
                  key={st.id}
                  className="col-12 col-md-6 mb-4 d-flex align-items-stretch"
                  data-aos={i === 0 ? "fade-right" : "fade-left"}
                  data-aos-delay={400 + i * 100}
                >
                  <div
                    className="p-4 rounded-3 shadow-sm bg-white border border-light transition-transform duration-300 hover-scale"
                    // style={{ color:"#008cff" }}
                  >
                    <div className="d-flex align-items-center mb-3">
                      <div
                        className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                        style={{
                          width: "70px",
                          height: "70px",
                          background: "#0663ad",
                          // border: "3px solid #f9b617",
                          color: "#fff",
                          fontSize: "2rem",
                        }}
                      >
                        <FaUserTie />
                      </div>
                      <div>
                        <h5 className="mb-0 fw-bold" style={{ color: "black" }}>
                          {st.name}
                        </h5>
                        <p className="text-dark mb-0">{st.role}</p>
                        {st.rating && renderStars(st.rating)}
                      </div>
                    </div>
                    <p
                      className="position-relative"
                      style={{ minHeight: "72px" }}
                    >
                      <span
                        style={{
                          position: "relative",
                          zIndex: 1,
                          textAlign: "justify",
                        }}
                      >
                        {st.quote}
                      </span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <div
              className="d-flex justify-content-center mt-4"
              data-aos="fade-up"
              data-aos-delay="600"
            >
              {Array.from({ length: totalPages }).map((_, index) => (
                <span
                  key={index}
                  className={`me-2 rounded-circle ${
                    index === activeDot ? "bg-white" : "bg-secondary"
                  }`}
                  style={{
                    width: "8px",
                    height: "8px",
                    cursor: "pointer",
                    transition: "background 0.3s ease",
                  }}
                  onClick={() => setActiveDot(index)}
                ></span>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section
          className="text-center py-5"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div>
            <h2 className="mb-4" data-aos="zoom-in" data-aos-delay="300">
              <span style={{ color: "#0663ad" }}>Ready to</span>{" "}
              <span className="text-dark">Get Hired?</span>
            </h2>
            <div className="section-divider  mb-4"></div>
            <p
              className="lead mb-4 text-dark"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              Enroll today and transform your career trajectory.
            </p>
            <button
              className="btn text-white fw-semibold px-5 py-3 btn-small rounded-pill transition-transform duration-300 hover-scale"
              style={{ background: "#0663ad" }}
              onClick={handleOpenModal}
              data-aos="zoom-in"
              data-aos-delay="450"
            >
              Apply Now
            </button>
          </div>
        </section>

        {/* Apply Now Form */}
        {showModal && (
          <div
            className="modal modal-enhanced fade show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.7)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div
                className="modal-content modal-content-enhanced"
                style={{ maxHeight: "600px", overflowY: "auto" }}
                data-aos="zoom-in"
              >
                <div
                  className="modal-header border-0 pb-0"
                  style={{
                    background: "linear-gradient(135deg, #0663ad, #008cff)",
                    padding: "0.75rem 1rem",
                  }}
                >
                  <h3
                    className="modal-title text-white mb-2 fw-bold"
                    style={{ fontSize: "1rem" }}
                  >
                    <i className="bi bi-mortarboard me-2"></i>
                    Registration Form
                  </h3>
                  <button
                    type="button"
                    className="btn-close btn-close-white"
                    onClick={() => setShowModal(false)}
                    style={{ fontSize: "0.7rem" }}
                  ></button>
                </div>
                <div
                  className="modal-body p-3"
                  style={{
                    background: "linear-gradient(180deg, #f8f9fa, white)",
                  }}
                >
                  <div className="text-center mb-3">
                    <div
                      className="d-inline-flex align-items-center justify-content-center  rounded-circle mb-2"
                      style={{
                        width: "50px",
                        height: "50px",
                        background: "#008cff",
                      }}
                    >
                      <i className="bi bi-book text-dark fs-4"></i>
                    </div>
                    <p className="text-muted" style={{ fontSize: "0.8rem" }}>
                      Ready to start your learning journey?
                    </p>
                  </div>

                  <form>
                    <div className="mb-2">
                      <label
                        className="form-label fw-semibold text-dark"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Full Name
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-enhanced form-control-sm"
                        required
                        placeholder="Enter your full name"
                      />
                    </div>

                    <div className="mb-2">
                      <label
                        className="form-label fw-semibold text-dark"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="form-control form-control-enhanced form-control-sm"
                        required
                        placeholder="Enter your email address"
                      />
                    </div>

                    <div className="mb-2">
                      <label
                        className="form-label fw-semibold text-dark"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Mobile Number
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-enhanced form-control-sm"
                        required
                        maxLength={10}
                        pattern="\d{10}"
                        placeholder="Enter your mobile number"
                      />
                    </div>

                    <div className="mb-3">
                      <label
                        className="form-label fw-semibold text-dark"
                        style={{ fontSize: "0.8rem" }}
                      >
                        Send Message
                      </label>
                      <textarea
                        id="message"
                        className="form-control form-control-sm"
                        rows="3"
                        placeholder="Type your message here..."
                        required
                      ></textarea>
                    </div>

                    <div className="d-flex gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-outline-secondary px-3 py-1 rounded-pill"
                        onClick={() => setShowModal(false)}
                        style={{ fontSize: "0.8rem" }}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-submit text-white px-3 py-1 rounded-pill"
                        style={{
                          fontSize: "0.8rem",
                          backgroundColor: "#0663ad",
                          transition: "all 0.3s ease",
                        }}
                      >
                        <i className="bi bi-send me-1"></i>
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}

        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default PlacementPage;
